export default "__VITE_ASSET__B1w7aFx8__"